import React from "react";
import axios from "axios";
import Alert from "react-s-alert";

const Adders = ({ proposal, customer, dealerFee, props, apiUrl }) => {
  const addTreeTrim = () => {
    axios
      .post(apiUrl, {
        method: "add_tree_trim",
        financing_id: customer.financeId,
        project_id: customer.projectID,
        Amount__c: proposal.treeTrimAmount * dealerFee,
      })
      .then((res) => {
        // console.log(res.data)
        props.getCustomer();
        Alert.success(`	Tree Trim/Removal added to Incentives`, {
          position: "top-right",
          effect: "flip",
          beep: false,
          timeout: 5000,
          offset: 100,
          color: "rgba(255, 255, 255, 0.927)",
        });
      });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        justifyContent: "flex-start",
      }}
    >
      {/* <span style={{ width: '115px' }}>Adders: </span> */}
      {proposal.hasNest === "1" && <span className="hasAdder">1 - Therm</span>}
      {["2", "3"].includes(proposal.hasNest) && (
        <span className="hasAdder">2 - Therm</span>
      )}
      {proposal.modCount <= 9 && <span className="hasAdder">Small System</span>}
      {proposal.ionRebate === "1" ? (
        <span className="hasAdder">Cust Cash</span>
      ) : (
        proposal.ionRebate === "2" && <span className="hasAdder">Rep Cash</span>
      )}
      {+proposal.security > 0 && <span className="hasAdder">Security</span>}
      {proposal.ionRebate2 === "1" ? (
        <span className="hasAdder">BLK Cust Cash</span>
      ) : (
        proposal.ionRebate2 === "2" && (
          <span className="hasAdder">BLK Rep Cash</span>
        )
      )}
      {+proposal.panelBonus > 0 && (
        <span className="hasAdder">Panel Bonus</span>
      )}
      {proposal.ballast === "1" && <span className="hasAdder">Ballast</span>}
      {proposal.groundMount === "1" && (
        <span className="hasAdder">Ground Mount</span>
      )}
      {proposal.pSolar === "1" && <span className="hasAdder">Pool Solar</span>}
      {["1", "2"].includes(proposal.msp) && (
        <span className="hasAdder">MSP Upgrade</span>
      )}
      {proposal.critterGuard === "1" && (
        <span className="hasAdder">Critter Guard</span>
      )}
      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].includes(+proposal.battery10) && (
        <span className="hasAdder">
          {proposal.battery10 * 2}-Enphase Battery{" "}
        </span>
      )}
      {+proposal.battery10 > 20 && +proposal.battery10 < 31 ? (
        <span className="hasAdder">
          {proposal.battery10 - 20}-Enphase 10c Battery{" "}
        </span>
      ) : (
        ""
      )}
      {+proposal.battery10 >= 11 && +proposal.battery10 < 20 && (
        <span className="hasAdder">
          Tesla Battery x{proposal.battery10 - 10}
        </span>
      )}
      {+proposal.expansionPack > 0 && (
        <span className="hasAdder">
          Expansion Pack x{proposal.expansionPack}
        </span>
      )}
      {proposal.travel === "1" && <span className="hasAdder">Travel</span>}
      {proposal.townhome === "1" && <span className="hasAdder">Townhome</span>}
      {proposal.pvSystemAddOn === "1" && (
        <span className="hasAdder">PV System Add-On</span>
      )}
      {+proposal.reroof > 0 && <span className="hasAdder">Reroof</span>}
      {proposal.treeTrim === "1" && (
        <span onClick={() => addTreeTrim()} className="hasAdder">
          Tree Trim
        </span>
      )}
      {!!+proposal.utilityReview && (
        <span className="hasAdder">Utility Review</span>
      )}
      {proposal.preferredUtility === "1" && (
        <span className="hasAdder">Preferred Utility</span>
      )}
      {proposal.sameDay === "1" && <span className="hasAdder">Same Day</span>}
      {proposal.referral === "1" && <span className="hasAdder">Referral</span>}
      {proposal.sustainable === "1" && (
        <span className="hasAdder"> Portland</span>
      )}
      {proposal.smartHome === "1" && (
        <span className="hasAdder"> Smart Home</span>
      )}
      {proposal.hvac === "1" && <span className="hasAdder"> HVAC</span>}
      {proposal.led === "1" && <span className="hasAdder"> LED Lighting</span>}
      {proposal.turf === "1" && <span className="hasAdder"> Landscaping</span>}
      {proposal.windows === "1" && (
        <span className="hasAdder"> Windows/Doors</span>
      )}
      {proposal.water === "1" && <span className="hasAdder"> Water</span>}
      {proposal.military > 0 && (
        <span className="hasAdder"> Military Discount</span>
      )}
      {proposal.miscCash === "1" && (
        <span className="hasAdder">MISC Cash - ${proposal.miscCashAmount}</span>
      )}
      {proposal.blackFriday === "1" && (
        <span className="hasAdder"> Black Friday</span>
      )}
      {proposal.blackFriday === "2" && (
        <span className="hasAdder"> Christmas Promo</span>
      )}
      {+proposal.freeMonths > 0 && (
        <span className="hasAdder">
          6 Months Free - {proposal.freeMonths === "1" ? "Cust" : "Rep"}
        </span>
      )}
      {proposal.shadeWaiver === "1" && (
        <span className="hasAdder"> Shade Disclosure</span>
      )}
      {+proposal.acCoupled > 0 && <span className="hasAdder"> AC Coupled</span>}
      {+proposal.waterSoftener > 0 && (
        <span className="hasAdder"> Water Softener</span>
      )}
    </div>
  );
};

export { Adders };
